import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import {
  MemberWalletVo,
  WalletConfigVo,
  QueryChangeLog,
  MemberWalletLogVo,
  MemberWithdrawalApplyVo,
  WithdrawalApplyPendingRecordVo,
  WithdrawalSettleVo,
  CurrencyWithdrawalMethodVo,
  MemberWithdrawalMethodVo,
  PayoneerAccount
} from './types';

/* *
 * 会员余额
 * */
export const walletDetail = (): AxiosPromise<MemberWalletVo> =>
  request({
    url: '/balance/api/wallet/detail',
    method: 'get'
  });
/**
 *
 * 会员余额日志
 */
export const walletChangeLog = (params: QueryChangeLog): AxiosPromise<MemberWalletLogVo> =>
  request({
    url: '/balance/api/wallet/changeLog',
    method: 'get',
    params
  });

/**
 * 提现申请列表
 *
 */
export const withdrawalApplyList = (params: QueryChangeLog): AxiosPromise<MemberWithdrawalApplyVo[]> =>
  request({
    url: '/balance/api/withdrawal/apply/list',
    method: 'get',
    params
  });

/**
 * 钱包select选项配置
 **/
export const walletConfig = (): AxiosPromise<WalletConfigVo> =>
  request({
    url: '/balance/api/wallet/config',
    method: 'get'
  });

/**
 * 钱包 驳回提现记录
 **/
export const walletPendingRecord = (): AxiosPromise<WithdrawalApplyPendingRecordVo> =>
  request({
    url: '/balance/api/withdrawal/apply/pending/record',
    method: 'get'
  });
/**
 * C端提现结算页信息
 */

export const walletApplySettleInfo = (): AxiosPromise<WithdrawalSettleVo> =>
  request({
    url: '/balance/api/withdrawal/apply/settle/info',
    method: 'get'
  });
/**
 * 提现发送验证码邮件
 */

export const walletVerficationCode = () =>
  request({
    url: '/balance/api/withdrawal/apply/send/verification/code',
    method: 'get'
  });
/**
 * 提现发起申请
 */
export const walletApplyCreate = (data: { verificationCode: string }) => {
  return request({
    url: '/balance/api/withdrawal/apply/create',
    method: 'post',
    data
  });
};
/**
 * 提现方式列表
 */

export const walletListByCurrency = (): AxiosPromise<CurrencyWithdrawalMethodVo[]> =>
  request({
    url: '/balance/api/withdrawal/method/listByCurrency',
    method: 'get'
  });

/**
 * 会员提现方式详情
 */

export const walletMethodDetail = (): AxiosPromise<MemberWithdrawalMethodVo> =>
  request({
    url: '/balance/api/member/withdrawal/method/detail',
    method: 'get'
  });

/**
 * 提现方式获取payoneer账号
 */

export const walletPayoneerAccount = (params: { methodDetailId?: number }): AxiosPromise<PayoneerAccount> =>
  request({
    url: '/balance/api/member/withdrawal/method/payoneer/account',
    method: 'get',
    params
  });

/**
 * 提现方式payoneer注册地址
 */

export const walletPayoneerLink = (params: { methodDetailId?: number }): AxiosPromise<{ link: string }> =>
  request({
    url: '/balance/api/member/withdrawal/method/payoneer/registration/link',
    method: 'get',
    params
  });

/**
 * 会员提现方式保存
 */
export const walletMethodSave = (data: WithdrawalApplyPendingRecordVo) => {
  return request({
    url: '/balance/api/member/withdrawal/method/save',
    method: 'post',
    data
  });
};
/*
 * 驳回提现申请修改地址
 */
export const walletUpdateAccount = (data: WithdrawalApplyPendingRecordVo) => {
  return request({
    url: '/balance/api/withdrawal/apply/pending/update/account',
    method: 'post',
    data
  });
};
